/**
 * Stable CSS class names for E2E — Linked accounts tab.
 */
export const LAC = {
    page: 'linked-accounts-page',
    toolbarSection: 'linked-accounts-page__toolbar-section',
    loadingWrap: 'linked-accounts-page__loading-wrap',
    inputTextfieldCustomerPhone: 'linked-accounts-input--textfield-customer-phone',
    gridSection: 'linked-accounts-page__grid-section',
    datagrid: 'linked-accounts-page__datagrid',
    inputLinkCustomerNo: 'linked-accounts-input--link-customer-no',
} as const;

export const lacCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
